import { css } from '@emotion/react'
import { Colors } from '~/shared/styles'

export const styles = {
  button: css`
    width: 100%;
    height: 40px;

    padding: 14px 0;

    display: flex;
    align-items: center;
    justify-content: center;

    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 12px;
    color: ${Colors.LIGHT_1};

    background: ${Colors.ACCENT_1};
    border-radius: 8px;
    border: none;

    cursor: pointer;
    outline: none;

    &:hover {
      background: ${Colors.ACCENT_2};
    }

    &:active,
    &:focus {
      box-shadow: 0 0 0 3px rgba(239, 69, 17, 0.35);
    }

    &:disabled {
      opacity: 0.8;
    }
  `,
}
